import { render } from "./WishlistButton.vue?vue&type=template&id=56525fd2&scoped=true"
import script from "./WishlistButton.vue?vue&type=script&lang=js"
export * from "./WishlistButton.vue?vue&type=script&lang=js"

import "./WishlistButton.vue?vue&type=style&index=0&id=56525fd2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56525fd2"]])

export default __exports__